/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { VALIDATION_MSG_TYPES } from 'utils/const';

const initialState = {
  selectedFile: null,
  openValidationModal: false,
  isUploading: false,
  hasUploaded: false,
  uploadErrorMsg: '',
  isValidating: false,
  validationProgressPercent: 0,
  haveValidated: false,
  isValid: false, // criteria: can have warnings, but no errors
  isSavingChanges: false,
  isCancellingChanges: false,
  validationMsgs: [],
};

const vinValidationSlice = createSlice({
  name: 'vinValidation',
  initialState,
  reducers: {
    // file upload and validation actions
    uploadInitiated: (state, action) => {
      state.selectedFile = action.payload;
      state.uploadErrorMsg = '';
      state.hasUploaded = false;
      state.isValidating = false;
      state.validationProgressPercent = 0;
      state.haveValidated = false;
      state.isValid = false;
      state.validationMsgs = [];
      state.openValidationModal = true; // timeout
      // reset file version history states if file upload is trigerred from file version history modal
      state.openFileVersionHistory = false;
      state.pageNumber = 1;
      state.hasReachedFirstVersion = false;
      state.allFileVersions = [];
      state.openDeleteVersionConfirmationModal = false;
    },
    uploadInProgress: (state) => {
      state.isUploading = true;
    },
    uploadedSuccessfully: (state) => {
      state.isValidating = true;
      state.isUploading = false;
      state.hasUploaded = true; // timeout
    },
    uploadErrored: (state, action) => {
      state.uploadErrorMsg = action.payload;
      state.isUploading = false;
    },
    uploadCancelled: (state) => {
      state.isUploading = false;
      state.isValidating = false;
      state.openValidationModal = false;
      // these 4 state transitins below might not be required .... check that too
      state.validationProgressPercent = 0; // timeout
      state.haveValidated = false; // timeout
      state.isValid = false; // timeout
      state.validationMsgs = []; // timeout
    },
    validationInProgress: (state, action) => {
      state.validationProgressPercent = action.payload;
    },
    addToValidationMsgs: (state, action) => {
      state.validationMsgs = [...state.validationMsgs, ...action.payload];
      const hasErrors = state.validationMsgs.some(
        (msg) => msg.type === VALIDATION_MSG_TYPES.ERROR,
      );
      if (hasErrors) {
        state.isValid = false;
      } else {
        state.isValid = true;
      }
    },
    reachedLastValidationMsg: (state) => {
      state.isValidating = false;
      state.haveValidated = true;
    },
    cancelledChanges: (state) => {
      state.isCancellingChanges = true;
    },
    validationCancelled: (state) => {
      state.isCancellingChanges = false;
      state.isValidating = false;
      state.openValidationModal = false;
      state.validationProgressPercent = 0; // timeout
      state.haveValidated = false; // timeout
      state.isValid = false; // timeout
      state.validationMsgs = []; // timeout
    },
    savingChanges: (state) => {
      state.isSavingChanges = true;
    },
    savedChanges: (state) => {
      state.isSavingChanges = false;
      state.openValidationModal = false;
      state.validationProgressPercent = 0; // timeout
      state.haveValidated = false; // timeout
      state.isValid = false; // timeout
      state.validationMsgs = []; // timeout
    },
  },
});

export default vinValidationSlice.reducer;
export const {
  uploadInitiated,
  uploadInProgress,
  uploadedSuccessfully,
  uploadErrored,
  uploadCancelled,
  validationInProgress,
  addToValidationMsgs,
  reachedLastValidationMsg,
  validationCancelled,
  cancelledChanges,
  savingChanges,
  savedChanges,
} = vinValidationSlice.actions;
